export const ORDER_ITEMS_GET_LIST = "/orderitems";